import { TemplatedCampaignManagement } from 'components/Shared/Permission/enums'
import { isPast } from 'date-fns'
import { useNewTranslation } from 'hooks'
import { usePermission } from 'hooks/permissions'
import ReminderAlert from 'particles/Alert/ReminderAlert'
import React from 'react'
import { useSelector } from 'react-redux'
import { parseBackendDate } from 'services/dates'
import { selectCampaignByTemplateData } from 'state'
import { CAMPAIGN_STATUS_ENUM } from 'state/campaigns'
import { selectTasks } from 'state/tasks'

const PaymentBanner = () => {
    const [t] = useNewTranslation()
    const isInternalPermission = usePermission(TemplatedCampaignManagement.CreateAndEditBriefsForInternal)
    const tasksList = useSelector(selectTasks)
    const campaign = useSelector(selectCampaignByTemplateData)

    if (campaign?.status === CAMPAIGN_STATUS_ENUM.FOR_REVIEW && !isInternalPermission) {
        return (
            <ReminderAlert
                form="info"
                width="100%"
                title={t(
                    'campaign.template.step3.paymentConfirmation.paymentConfirmation.infoReminder.waitForReview.title',
                )}
                subtext={t(
                    'campaign.template.step3.paymentConfirmation.paymentConfirmation.infoReminder.waitForReview.subtext',
                )}
            />
        )
    }

    if (campaign?.status === CAMPAIGN_STATUS_ENUM.LIVE && isPast(new Date(campaign.time_window.start))) {
        return (
            <ReminderAlert
                form="positive"
                width="100%"
                title={t(
                    'campaign.template.step3.paymentConfirmation.paymentConfirmation.postiveReminder.passReviewed.title',
                )}
                subtext={t(
                    'campaign.template.step3.paymentConfirmation.paymentConfirmation.postiveReminder.passReviewed.subtext',
                    {
                        campaignStartDate: parseBackendDate(campaign.time_window.start, campaign.country),
                    },
                )}
            />
        )
    }

    if (campaign?.status === CAMPAIGN_STATUS_ENUM.LIVE) {
        const taskId = tasksList?.[0]?.uuid
        const stepId = tasksList?.[0]?.steps[0]?.uuid
        return (
            <ReminderAlert
                form="positive"
                width="100%"
                title={t(
                    'campaign.template.step3.paymentConfirmation.paymentConfirmation.postiveReminder.campaignStart.title',
                )}
                subtext={t(
                    'campaign.template.step3.paymentConfirmation.paymentConfirmation.postiveReminder.campaignStart.subtext',
                )}
                action={{
                    label: t(
                        'campaign.template.step3.paymentConfirmation.paymentConfirmation.postiveReminder.campaignStart.button',
                    ),
                    callback: () => {
                        if (taskId && stepId) {
                            window.location.href = `/submissions/review?campaign=${campaign.uuid}&viewType=overview&entry=campaign_detail&task=${taskId}&step=${stepId}`
                        }
                    },
                }}
            />
        )
    }
    return null
}

export default PaymentBanner
